import { Images } from "lucide-react";
import { resolveImg } from "../../lib/api";

export const ProductCard = ({ product, onClick, index = 0 }) => {
  const count = product.images?.length || (product.image_url ? 1 : 0);
  return (
    <button
      onClick={() => onClick(product)}
      data-testid={`product-card-${product.id}`}
      className="group text-left fade-up"
      style={{ animationDelay: `${index * 90}ms` }}
    >
      <div className="relative overflow-hidden aspect-[4/5] bg-obsidian-2 border border-white/5">
        <img
          src={resolveImg(product.image_url)}
          alt={product.name}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-700 ease-in-out group-hover:scale-105"
        />
        {product.featured && (
          <span className="absolute top-4 left-4 font-accent text-[10px] tracking-[0.25em] uppercase bg-champagne text-obsidian px-3 py-1">
            Featured
          </span>
        )}
        {count > 1 && (
          <span className="absolute top-4 right-4 inline-flex items-center gap-1 bg-black/50 text-ink text-[11px] px-2 py-1" data-testid="image-count-badge">
            <Images size={12} strokeWidth={1.5} /> {count}
          </span>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
      </div>
      <div className="mt-5">
        <p className="font-accent text-[10px] tracking-[0.25em] uppercase text-champagne/80">
          {product.category}
        </p>
        <h3 className="font-heading text-2xl text-ink mt-1 group-hover:text-champagne transition-colors duration-300">
          {product.name}
        </h3>
        {product.price && <p className="text-ash text-sm mt-1 tracking-wide">{product.price}</p>}
      </div>
    </button>
  );
};
